"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.includeNewSelections = void 0;
var userGroups_1 = require("utils/userGroups");
var includeNewSelections = function (action, selections, groupOptions) {
    if ((0, userGroups_1.isCategoryGroup)(action.option))
        return selections
            .filter(function (g) { return !(0, userGroups_1.isCategoryGroup)(g); })
            .concat((0, userGroups_1.getGroupsByCategoryId)(groupOptions, action.option.id).filter(function (categoryGroup) {
            return !selections.some(function (selectedGroup) { return selectedGroup.id === categoryGroup.id; });
        }));
    return selections;
};
exports.includeNewSelections = includeNewSelections;
